/**
 * Free age of an excursion (`details.excursion.free_under_age`, whole years 1–11).
 * Children under it are booked as free « infants »; from it to 11 the child
 * price applies; 12 and over the adult price. Not set: the historical labels
 * (infants 1-2 free, children 3-11) are kept unchanged.
 */
export const FREE_AGE_MIN = 1;
export const FREE_AGE_MAX = 11;

export const freeUnderAge = (value) => {
  const n = Number(value);
  return Number.isInteger(n) && n >= FREE_AGE_MIN && n <= FREE_AGE_MAX ? n : null;
};

/** Labels of the age bands for a listing (or a booking snapshot). */
export const ageBandLabels = (t, value) => {
  const age = freeUnderAge(value);
  if (age === null) {
    return {
      children: t('serviceDetail.booking.children'),
      infants: t('serviceDetail.booking.infants'),
      note: t('serviceDetail.booking.infantsFreeNote'),
      infantsLine: (count) => t('serviceDetail.booking.infantsLine', { count }),
      detailChildren: t('bookingDetail.children'),
      detailInfants: t('bookingDetail.infants'),
    };
  }
  const years = t('excursionAges.years', { count: age });
  return {
    children: t('excursionAges.childrenFrom', { from: age }),
    infants: t('excursionAges.infantsUnder', { age: years }),
    note: t('excursionAges.note', { age: years }),
    infantsLine: (count) => t('excursionAges.infantsLine', { count, age: years }),
    detailChildren: t('excursionAges.childrenFrom', { from: age }),
    detailInfants: t('excursionAges.infantsUnder', { age: years }),
  };
};
